module.exports = __webpack_public_path__ + "img/9791185871561.da60ad56.jpg";